import { Button } from 'primereact/button'
import { useTranslation } from 'react-i18next'

import { Link, useLocation, useSearchParams } from 'react-router-dom'
import { isBranchPage } from 'routers/routes'

const NotFound = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const message =
    searchParams.get('message') ||
    (location.state as { message?: string } | null)?.message

  return (
    <div className="w-screen h-screen flex align-items-center justify-content-center flex-column gap-6">
      <div className="text-center px-4">
        <p className="text-2xl font-bold">{t('Page not found')}</p>
        {message ? (
          <p className="text-color-secondary line-height-3 m-0">{message}</p>
        ) : null}
      </div>
      {isBranchPage ? (
        <div
          onClick={() => {
            window.location.replace('/')
          }}
        >
          <Button size="large">{t('Go to home page')}</Button>
        </div>
      ) : (
        <Link to={'/'}>
          <Button size="large">{t('Go to home page')}</Button>
        </Link>
      )}
    </div>
  )
}

export default NotFound
